/**
 * REGISTA AI: Main Application Entry Point
 * 
 * React application with routing, authentication, and global providers.
 * Features D1 backend integration and modern React patterns.
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.tsx';
import { ApiProvider } from './lib/api-client.tsx';
import { AuthProvider } from './lib/auth.tsx';
import './styles/globals.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <ApiProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </ApiProvider>
    </BrowserRouter>
  </React.StrictMode>,
);